/** @jsxImportSource @emotion/react */

import SwitcherStyle from './IDSSwitcherStyle'
import Tag from 'apollo-react/components/Tag'
import { switcherRedirect } from './common'

const IDSSwitcherOption = ({ name, subdomain, signInImage, accountless }) => {
  return (
    <a
      data-testid="switcher-option"
      css={SwitcherStyle.switcherOption}
      href={switcherRedirect(subdomain)}
    >
      {accountless && (
        <Tag style={SwitcherStyle.tag} label="New" variant="decorative2" />
      )}
      <div css={SwitcherStyle.signInImage}>
        {signInImage && (
          <img alt="Iqvia drugdev" title="Iqvia drugdev" src={signInImage} />
        )}
      </div>
      <div css={SwitcherStyle.tenantName}>
        <span>{name}</span>
      </div>
    </a>
  )
}
export default IDSSwitcherOption
